module.exports = __webpack_public_path__ + "static/img/GlassesMan-3.fe3407f4.png";